/**
 * SynQ — cross-service music controller
 *
 * Its web-accessible resources are split by origin: the hashed `tabs/onboard.*`
 * files are exposed only to the music services (Apple Music, Spotify, YouTube
 * Music, Amazon Music), while the one resource exposed to SynQ's own site,
 * `https://www.synqapp.io/*`, is `assets/icon.png`. That file is static (no
 * `use_dynamic_url`) and fetchable at a fixed URL, but only from synqapp.io.
 *
 * So SynQ is detectable, but only by synqapp.io. Elsewhere the icon is
 * unreachable and a negative says nothing.
 *
 * Manifest verified against version 4.0.8.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jcdmcpefbebkldopabclefjaggejocff';

export const synq: ExtensionDefinition = {
  id: ID,
  name: 'SynQ for Spotify, YouTube, Amazon Music, more',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  requiredOrigin: 'https://www.synqapp.io',
  notes:
    'The only non-hashed, non-origin-rotating WAR is assets/icon.png, scoped to ' +
    'www.synqapp.io. Only that origin can detect it; conclusive there.',
  signals: [
    {
      id: 'war-icon-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icon.png via <img> — the sole static resource exposed to ' +
        'www.synqapp.io, loading without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/icon.png'),
    },
  ],
};
